import React, { useContext } from "react";
import styled from "styled-components";
import _ from "lodash";
// import { PieChart, Pie, Sector, Cell } from "recharts";
import { AuthContext } from "../../../../auth-context";
import { DashboardContext } from '../../dashboard-context'
import { ResponsivePie } from '@nivo/pie'
import { ThemeContext } from 'styled-components'

const Container = styled.div`
  max-width: 1600px;
`;

const ChartContainer = styled.div`
  border-radius: 8px;
  background: #08091f;
  display: flex;
  height: 280px;
  width: 100%;
  padding: 12px;

  @media(max-width: 1420px) {
    height: 240px;
    padding: 16px;
    width: 560px;
  }

  @media (max-width: 590px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: unset;
    width: 100%;
  }

  tspan {
    color: #fff;
    fill: #fff;
  }
`;

const Title = styled.h2`
  padding-bottom: 8px;
  margin: 0 auto;
  color: #181818;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
  text-align: center;
  @media (max-width: 1420px) {
    text-align: left;
  }
`;

const LabelContainer = styled.div`
  margin-left: 32px;

  @media (max-width: 530px) {
    padding-top: 32px;
  }
`;

const GoalLabelContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 0px;
  width: 140px;
  p {
    color: #fff;
  }
`;
const GoalDot = styled.div`
  background: ${(props) => (props.color ? props.color : "#f4b300")};
  border-radius: 100px;
  height: 16px;
  width: 16px;
  margin-right: 8px;
`;

const PieContainer = styled.div`
  height: 200px;
  width: 300px;
  margin-top: 26px;
  @media(max-width: 1420px) {
    margin-top: 0px;
  }
`;

const GoalLabel = ({ color, text }) => {
  return (
    <GoalLabelContainer>
      <GoalDot color={color} />
      <p>{text}</p>
    </GoalLabelContainer>
  );
};

const LineChart = () => {
  const { user } = useContext(AuthContext);
  const theme = useContext(ThemeContext)
  const { filterGroupID, clientsTrainerID } = React.useContext(DashboardContext);
  
  let totalFatLoss = 0
  let totalMuscleGain  = 0
  let totalReverse  = 0
  let totalMaintenance  = 0

  let accounts =_.cloneDeep(user.accounts);
  
  accounts.forEach((entry, index) => {
    if (
      entry.trainer_permission &&
      entry.report_date &&
      entry.claimed === 1 &&
      (filterGroupID === 0 || entry.groups.includes(filterGroupID)) && (clientsTrainerID === '' || entry.trainers.includes(clientsTrainerID))
    ) {
      if (entry.goal === 'MUSCLE GAIN')
        totalMuscleGain++
      if (entry.goal === 'FAT LOSS')
        totalFatLoss++
      if (entry.goal === 'REVERSE DIETING')
        totalReverse++
      if (entry.goal === 'MAINTENANCE')
        totalMaintenance++
    }
  })

  const goalTotal =
    totalFatLoss +
    totalMuscleGain +
    totalReverse +
    totalMaintenance;
  const fatLossRatio = Math.round(((totalFatLoss / goalTotal) * 100) * 10) / 10;
  const muscleGainRatio = Math.round(((totalMuscleGain / goalTotal) * 100) * 10) / 10;
  const ReverseRatio = Math.round(((totalReverse / goalTotal) * 100) * 10) / 10;
  const MaintenanceRatio = Math.round(((totalMaintenance / goalTotal) * 100) * 10) / 10;

  let PieData = [
    {
      id: "Fat Loss",
      label: "Fat Loss",
      value: isNaN(fatLossRatio) ? 0 : fatLossRatio,
    },
    {
      id: "Muscle Gain",
      label: "Muscle Gain",
      value: isNaN(muscleGainRatio) ? 0 : muscleGainRatio,
    },
    {
      id: "Reverse Dieting",
      label: "Reverse Dieting",
      value: isNaN(ReverseRatio) ? 0 : ReverseRatio,
    },
    {
      id: "Maintenance",
      label: "Maintenance",
      value: isNaN(MaintenanceRatio) ? 0 : MaintenanceRatio,
    },
  ];

  let chartColors = ["#5b30f2", "#f28730", "#08bf3e", "#e1f531"];

  for (let i = 3; i > 0; i--) {
    if (PieData[i].value === 0) {
      PieData.splice(i, 1);
      chartColors.splice(i, 1);
    }
  }

  return (
    <Container>
      <Title>Goal Distribution</Title>
      <ChartContainer>
        <PieContainer>
          <ResponsivePie
            margin={{ top: 20, right: 60, bottom: 20, left: 60 }}
            data={PieData}
            innerRadius={0.90}
            isInteractive={false}
            enableArcLabels={false}
            arcLabelsTextColor="#FFFFFF"
            arcLabelsLinkColor="#FFFFFF"
            arcLinkLabelsTextColor="#FFFFFF"
            arcLinkLabel={d => `${d.value}%`}
            arcLinkLabelsDiagonalLength={8}
            arcLinkLabelsHorizontalLength={8}
            radialLabelsLinkDiagonalLength={8}
            radialLabelsLinkHorizontalLength={8}
            enableSlicesLabels={false}
            padAngle={3}
            cornerRadius={15}
            colors={chartColors}
            startAngle={20}
            endAngle={380}
            animate={true}
          />
        </PieContainer>

        
        <LabelContainer>
          <GoalLabel color="#5b30f2" text={theme.goal["FAT LOSS"]} />
          <GoalLabel color="#f48630" text={theme.goal["MUSCLE GAIN"]} />
          <GoalLabel color="#08bd3d" text={theme.goal["REVERSE DIETING"]} />
          <GoalLabel color="#e2f631" text={theme.goal["MAINTENANCE"]} />
        </LabelContainer>
      </ChartContainer>

    </Container>
  );
};

export default LineChart;


